<template>
	<div>
		<b-modal
			id="formsmodal"
			v-model="showModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			size="lg"
			@hide="onModalHidden"
		>
			<main class="d-flex w-100 h-100">
				<section
					v-if="!fromJobSearch"
					class="candash-modal-left width-5"
				></section>
				<section :class="fromJobSearch ? 'w-100' : 'w95'">
					<header class="candash-modal-top p-3">
						<div class="width-97 ml-1">
							<div
								class="candash-modal-head"
								:class="fromJobSearch ? 'jobsearch' : ''"
							>
								<template v-if="fromJobSearch"
									>{{ form.formID }} details
								</template>
								<template v-else> {{ form.formName }}</template>
							</div>

							<div
								v-if="fromJobSearch"
								class="candash-desc-2 fam-mont fs-18 fw-B"
							>
								Add your latest {{ form.formID }} details to gain access
							</div>
							<div v-else class="candash-desc">
								Fill your {{ form.formName }} details
							</div>
						</div>
						<div
							class="d-flex justify-content-end pointer"
							@mouseenter="checkForChanges()"
							@click="
								changesDetected
									? (discardModal = true)
									: fromJobSearch
									? $emit('skip-modal')
									: $emit('close-modal')
							"
						>
							<img
								class="rotate-on-hover"
								src="../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
							/>
						</div>
					</header>
					<b-tabs
						class="dynamic-modal-tabs ml-3 mt-3"
						v-if="formDetails.formID == 'achievement'"
						v-model="tabIndex"
					>
						<b-tab
							title="Award"
							:disabled="disableAward"
							@click="
								disableAward ||
								(selectedTab == 'rewardField' && !newObject.parser)
									? ''
									: selectTab('rewardField')
							"
						>
						</b-tab>
						<b-tab
							title="Certificate"
							:disabled="disableCerti"
							@click="
								disableCerti ||
								(selectedTab == 'certificateField' && !newObject.parser)
									? ''
									: selectTab('certificateField')
							"
						>
						</b-tab>
						<b-tab
							title="Event"
							:disabled="disableEvent"
							@click="
								disableEvent ||
								(selectedTab == 'eventField' && !newObject.parser)
									? ''
									: selectTab('eventField')
							"
						>
						</b-tab>
					</b-tabs>
					<div class="candash-modal-body-11" :class="isApp && 'candash-modal-body-11-appheight'" v-if="formShimmer">
						<FormShimmer :shimmer="10" :from="'home'" :type="'laptop'" />
					</div>
					<div
					    class="candash-modal-body-11"
						:class="[
							isApp ? 'candash-modal-body-11-appheight' : '',
							formID == 'education' ? 'education-overflow-unset' : '',
							fromJobSearch ? 'jobsearch' : '',
						]"
						v-else
					>
						<b-row>
							<b-col
								v-for="(field, index) in basicArray"
								:key="index"
								:cols="
									field.key == 'summary' ||
									field.key == 'highlight' ||
									field.key == 'responsibility' ||
									field.key == 'description' ||
									field.controlType == 'boolean'
										? 12
										: field.key == 'uploadFile' && formID == 'achievement'
										? 6
										: getColumn(field)
								"
								class="relativeclass mt-2"
								:class="
									field.controlType == 'boolean'
										? 'd-flex align-items-center'
										: ''
								"
								v-show="!field.hide"
							>
								<div
									v-if="
										field.controlType == 'upload_file' && field.key == 'image'
									"
									class="topDiv mt-3 d-flex justify-content-center"
								>
									<ProfilePictureUpload
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
									/>
								</div>
								<div
									v-else-if="
										field.key == 'phoneNumber' || field.key == 'altPhoneNumber'
									"
									class="topDiv mt-3"
								>
									<PhoneNumber
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:code="getCountryCode(field)"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										@select-value="updateFieldValue(field, $event)"
										@select-country-code="updateCountryCode(field, $event)"
									/>
								</div>

								<div
									v-else-if="
										field.controlType == 'textarea' ||
										field.key == 'description'
									"
									class="topDiv mt-3"
								>
									<hr
										v-if="formID == 'project' && field.key == 'summary'"
										class="hr-back"
									/>

									<Textarea
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										:formID="formID"
										:limit="field.limit"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'location'"
									class="topDiv mt-3"
								>
									<LocationSearch
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										:formID="formID"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>
								</div>
								<div
									v-else-if="
										field.controlType == 'text' &&
										(field.key == 'institute' || field.key == 'companyName')
									"
									class="topDiv mt-3"
								>
									<Selectwithsearch
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:showError="getError(field)"
										:vmodel="getVmodel(field)"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<div
									v-else-if="
										(field.key == 'highlight' && formID == 'experience') ||
										(field.key == 'responsibility' && formID == 'project') ||
										(field.key == 'portfolio' && formID == 'personalDetails')
									"
									class="topDiv mt-3"
								>
									<MultipleInput
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:showError="getError(field)"
										:vmodel="getVmodel(field)"
										:limit="field.limit"
										:formID="formID"
										:fieldVal="field"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>
								</div>

								<div
									v-else-if="
										field.controlType == 'text' ||
										field.controlType == 'email' ||
										field.controlType == 'number'
									"
									class="topDiv mt-3"
								>
									<InputField
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:showError="getError(field)"
										:vmodel="getVmodel(field)"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'single_select'"
									class="topDiv mt-3"
								>
									<SelectCustom
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:api="field.apiEndpoint"
										:values="field.values"
										:dropdown="field.dropdown"
										:fieldType="field.fieldType"
										:showError="getError(field)"
										:vmodel="getVmodel(field)"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'multi_select'"
									class="topDiv mt-3"
								>
									<MultiSelectCustom
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:api="field.apiEndpoint"
										:values="field.values"
										:dropdown="field.dropdown"
										:fieldType="field.fieldType"
										:showError="getError(field)"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'rich_text_box'"
									class="topDiv mt-3"
								>
									<CustomQuillEditor
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
										:showError="getError(field)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'boolean'"
									class="topDiv mt-2 checkbox-pl14-1"
								>
									<Checkbox
										:id="field.key"
										:label="field.label"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>

								<div
									v-else-if="field.controlType == 'upload_file'"
									class="topDiv mt-3"
								>
									<UploadDocument
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
										:vmodel="originalData"
										@select-value="updateFieldValue(field, $event)"
										@update-check="updateCheckUpload"
										@file-removed="(e) => (newObject.fileRemoved = true)"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'multi_text'"
									class="topDiv mt-3"
								>
									<FormTags
										v-if="
											field.key === 'skillsUsed' || field.key === 'usedSkills'
										"
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
										:vmodel="getVmodel(field)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
										@changeErrStatus="touchedFields[field.key] = false"
										:suggestions="suggestions"
										@handle-typing="handleSkillTyping(field, $event)"
										@handle-focus="handleSkillFocus(field)"
										@load-next-page="loadNextSkillPage"
										@load-prev-page="loadPrevSkillPage"
										@reset-suggestions="handleSkillFocus(field)"
										:skillLoading="skillLoading"
										:skillScrollDir="skillScrollDir"
									/>
									<FormTags
										v-else
										:type="field.controlType"
										:label="field.label"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:id="field.key"
										@select-value="updateFieldValue(field, $event)"
										:fileFormat="field.fileFormat"
										:showError="getError(field)"
										:maxFileSize="field.maxFileSize"
										:vmodel="getVmodel(field)"
										@handle-input="handleInput(field)"
										@handle-blur="handleBlur(field)"
										@changeErrStatus="touchedFields[field.key] = false"
									/>
								</div>
								<div
									v-else-if="field.controlType == 'date'"
									class="topDiv mt-3"
								>
									<DateField
										:id="field.key"
										:label="
											formID == 'education' &&
											newObject.currentEducation &&
											field.key == 'yearOfPassout'
												? 'Expected end date'
												: field.label
										"
										:type="field.controlType"
										:mandatory="field.mandatory"
										:placeholder="field.placeholder"
										:vmodel="getVmodel(field)"
										:showError="getError(field)"
										:format="field.dateTimeFormat"
										:disabled="disableDateField(field)"
										:startDate="
											field.key == 'yearOfPassout'
												? newObject.yearOfJoining
												: field.key == 'endDate'
												? newObject.startDate
												: ''
										"
										@select-value="updateFieldValue(field, $event)"
									/>
								</div>
								<template
									v-if="touchedFields[field.key] && !validateField(field)"
								>
									<div
										:class="
											field.key == 'highlight' ||
											field.key == 'responsibility' ||
											field.key == 'portfolio' ||
											field.key == 'description' ||
											field.controlType == 'textarea'
												? 'new-error-pos-1'
												: 'new-error-pos'
										"
										class="newInt-required-validation-font mt-1"
									>
										{{ valText[field.key] }}
									</div>
									<!-- <div
										:class="
											field.key == 'highlight' ||
											field.key == 'responsibility' ||
											field.key == 'portfolio' ||
											field.key == 'description' ||
											field.controlType == 'textarea'
												? 'new-error-pos-1'
												: 'new-error-pos'
										"
										class="newInt-required-validation-font mt-1"
										v-if="field.limit > 0 && notAMultipleInput(field)"
									>
										{{ valText[field.key] }}
									</div> -->
								</template>
								<div
									v-else-if="
										field.key == 'summary' &&
										field.limit != null &&
										newObject.summary
									"
									class="candash-character-left"
									:class="
										formID == 'personalDetails'
											? 'perd-char-pos'
											: 'perd-char-pos-2'
									"
								>
									{{ field.limit - newObject.summary.length }}
									characters left
								</div>
								<div
									v-else-if="
										field.key == 'description' &&
										formID == 'achievement' &&
										field.limit != null &&
										newObject.description
									"
									class="candash-character-left perd-char-pos"
									:class="
										formID == 'personalDetails'
											? 'perd-char-pos'
											: 'perd-char-pos-2'
									"
								>
									{{ field.limit - newObject.description.length }}
									characters left
								</div>
							</b-col>
						</b-row>
					</div>
					<footer
						class="candash-modal-footer d-flex align-items-center"
						:class="
							(formType != 'edit' || newObject.parser) && !fromJobSearch
								? 'justify-content-between'
								: 'justify-content-end'
						"
					>
						<div class="position-relative" v-if="!fromJobSearch">
							<b-button
								v-if="formType != 'edit' || newObject.parser"
								class="candash-addBtn"
								:class="
									loading && saveAndAddNew
										? 'loader-class-save-new defaultCursor'
										: 'pointer'
								"
								@click="
									loading && saveAndAddNew ? '' : (saveAndAddNew = true),
										validateForm()
								"
							>
								{{ loading && saveAndAddNew ? "" : "Save & add New" }}
							</b-button>
							<div v-if="loading && saveAndAddNew" class="loader-pos-new">
								<Loader />
							</div>
						</div>

						<div
							class="d-flex align-items-center gap-3"
							@mouseenter="checkForChanges()"
						>
							<b-button
								class="candash-cancelBtn pointer"
								@click="
									changesDetected
										? (discardModal = true)
										: fromJobSearch
										? $emit('skip-modal')
										: $emit('close-modal')
								"
								>{{ fromJobSearch ? "Skip this" : "Cancel" }}</b-button
							>
							<div class="position-relative">
								<b-button
									class="candash-addBtn"
									:class="{
										'loader-class-update defaultCursor':
											loading && !saveAndAddNew && formType == 'edit',
										'loader-class-save defaultCursor':
											loading && !saveAndAddNew && formType != 'edit',
									}"
									@click="
										loading && !saveAndAddNew ? '' : (saveAndAddNew = false),
											validateForm()
									"
								>
									{{
										loading && !saveAndAddNew
											? ""
											: fromJobSearch
											? "Confirm & Proceed"
											: formType == "edit" && !newObject.parser
											? "Update"
											: "Save"
									}}</b-button
								>
								<div v-if="loading && !saveAndAddNew" class="loader-pos-new">
									<Loader />
								</div>
							</div>
						</div>
					</footer>
				</section>
			</main>
		</b-modal>
		<DiscardModal
			v-if="discardModal"
			:showModal="discardModal"
			@close-modal="discardModal = false"
			@discard-changes="
				(discardModal = false),
					fromJobSearch ? $emit('skip-modal') : $emit('close-modal')
			"
		/>
	</div>
</template>

<script>
import commonForm from "@/controllers/dashboard/mixin/commonForm.js";
import { getSuggestion } from "@/utils/apiFunctions";
import { Capacitor } from "@capacitor/core";

export default {
	name: "FormModal",
	mixins: [commonForm],
	props: {
		fromJobSearch: {
			type: Boolean,
			default: false,
		},
	},
	computed:{
		isApp(){
			return Capacitor.isNativePlatform();
		},
	}
};
</script>

<style>
@media (min-width: 1029px) {
	.new-error-pos {
		position: absolute;
		left: 31%;
	}
	.new-error-pos-1 {
		position: absolute;
		left: 15.5%;
	}
}
.mobf-pl-29 {
	padding-left: 29%;
}
.dynamic-modal-tabs {
	width: 445px;
	background-color: #d7e0ef;
	border-radius: 8px;
	padding: 2px;
}

.dynamic-modal-tabs ul {
	width: 100%;
}

.dynamic-modal-tabs ul li {
	width: calc(100% / 3);
}

.dynamic-modal-tabs .nav-tabs .nav-link {
	font-family: "Lato", sans-serif;
	font-size: 13px;
	font-weight: 600;
	color: #595959;
	width: 100%;
	text-align: center;
}

.dynamic-modal-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
	color: #ffffff;
	background-color: #20639b;
	border-radius: 8px;
}

.dynamic-modal-tabs .nav-tabs .nav-link.disabled,
.dynamic-modal-tabs .nav-tabs .nav-link:disabled {
	opacity: 0.5;
}
.perd-char-pos {
	padding-left: 16%;
}
.perd-char-pos-2 {
	padding-left: 14%;
}
.education-overflow-unset {
	overflow: unset;
}
.candash-modal-body-11-appheight {
    height: calc(100% - 185px) !important;
}
</style>
